import "@aihCustomBlueprint/Store/Reducer";
import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import ButtonPresentationPropsDefault from "@insite/mobius/Button/presentationProps";
import { css } from "styled-components";

// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder

// const widgets = IS_PRODUCTION
//     ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
//     : require.context("./Widgets", true, /\.tsx$/);
// enable hot module reloading for widgets

const services = require.context("./Services", true);
const onHotServiceReplace = addWidgetsFromContext(services);

if (module.hot) {
    module.hot.accept(services.id, () => onHotServiceReplace(require.context("./Services", true)));
}

const widgets = require.context("./Widgets", true, /\.tsx$/);

const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

const store = require.context("./Store", true);
store.keys().forEach(key => store(key));
if (module.hot) {
    module.hot.accept(store.id, () => onHotWidgetReplace(require.context("./Store", true)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// Load all the extensions to the base widgets. This includes style extensions.

const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

// load all pages. Without this they won't be included in the bundle

// in production, the widget extensions are included in the chunks created for widgets
// if (!IS_PRODUCTION) {
//     // load all widget extensions. They could be loaded individually instead
//     const widgetExtensions = require.context("./WidgetExtensions", true);
//     widgetExtensions.keys().forEach(key => widgetExtensions(key));
// }

setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 1100, 1370],
        maxWidths: [540, 540, 720, 960, 1370],
    },
    typography: {
        fontFamilyImportUrl: "https://fonts.googleapis.com/css?family=Roboto:400,400i,500,500i,700,700i,900,900i",
        body: {
            size: "14px",
            weight: 400,
            fontFamily: "'Roboto', sans-serif",
        },
        h3: {
            fontFamily: "'Roboto', sans-serif",
            weight: "bold",
            css: css`
                font-size: 1.2em;
                margin-top: 1.25em;
                margin-bottom: 1em;
                margin-bottom: 1rem;
                display: block;
            `,
        },
    },
    colors: {
        primary: {
            main: "#0072bc",
            contrast: "#ffffff",
        },
        secondary: {
            main: "#6C757D",
            contrast: "#000000",
        },
        danger: {
            main: "#ed1c24",
            contrast: "#ffffff",
        },
    },
    button: {
        defaultProps: {
            color: "primary",
            css: css`
                &:focus {
                    outline-style: none !important;
                }
            `,
        },
        primary: {
            ...ButtonPresentationPropsDefault,
            color: "primary",
            buttonType: "solid",
            hoverMode: "lighten",
            sizeVariant: "medium",
            css: css`
                border: 1px solid #707070;
                border-radius: 7px;
            `,
        },
        secondary: {
            ...ButtonPresentationPropsDefault,
            color: "danger",
            buttonType: "solid",
            hoverMode: "lighten",
            sizeVariant: "medium",
            css: css`
                border: 1px solid #707070;
                border-radius: 7px;
            `,
        },
    },
    globalStyle: {
        // Todo: need to check all the ids
        css: css`
            body {
                background: #fff;
                color: #333;
            }
        `,
    },
});
